import { createContext } from 'react'
import { LoaderFullScreen } from 'components/LoaderFullScreen/LoaderFullScreen'
import { LanguageSubscriber } from 'utils/api/Languages/types'
import { useLanguages } from 'utils/api/Languages/useLanguages'
import { FCWithChildren } from 'utils/types/FCWithChildren'

type LangContextType = {
  languages: LanguageSubscriber[]
}

const LangContext = createContext<LangContextType | null>(null)
const { Provider, Consumer } = LangContext

const LangContextProvider: FCWithChildren = ({ children }) => {
  const { isFetching: isFetchingLanguage, data } = useLanguages()

  if (isFetchingLanguage) {
    return <LoaderFullScreen />
  }

  return <Provider value={{ languages: data?.data }}>{children}</Provider>
}

export { LangContextProvider, Consumer as LangConsumer }
export default LangContext
